/* eslint simple-import-sort/imports: 2 */

// This import must be first (because Vuex must be imported first)
import { h } from "vue"; // No need to import h manually

import { registerVueComponent } from "@/lib/turbo.js";
import { setVueState } from "@/lib/vueStateBridge";

import { bootstrapApp } from "./setupVue";

export const setupVueComponent = (render, options = {}, props) => {
  const app = bootstrapApp(render, props);

  if (options) {
    app.config.globalProperties = {
      ...app.config.globalProperties,
      ...options.globalProperties
    };
  }

  return app;
};

export const renderVueComponent = (root, App, options = {}) => {
  // Find root node
  let node = root;
  if (typeof root === "string") {
    node = document.querySelector(`#${root}`);
  }
  if (node) {
    // Component is already mounted, do not remount
    if (node.getAttribute("data-v-app") !== null) return;

    // Get the properties BEFORE the app is instantiated
    const props = extractProps(node, options);

    const stateAttr = "state";
    const state = JSON.parse(node.getAttribute(stateAttr));

    if (state) {
      for (const key in state) {
        setVueState(key, state[key]);
      }

      node.removeAttribute(stateAttr);
    }

    const componentOptions = { ...options, props };
    delete componentOptions.props;

    const app = setupVueComponent(
      () => h(App, { props }),
      componentOptions,
      props
    );
    const component = app.mount(node);

    registerVueComponent(app);
    return component;
  }
};

export function extractProps(node, options) {
  let props = JSON.parse(node.getAttribute("data"));
  if (options.props) {
    props = {
      ...props,
      ...options.props
    };
  }
  return props;
}
